<template>
    <div class="account">
        <el-row class="main_header">
            <div class="main_header_item" v-if="postList.source_file">
                <el-input
                    v-model="queryParams.source_file"
                    placeholder="请输入源文件"
                    clearable
                    @keyup.enter.native="getList(1)"
                ></el-input>
            </div>
            <div class="main_header_item" v-if="postList.rid">
                <el-input v-model="queryParams.rid" placeholder="请输入负流向RID" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.business_rid">
                <vSearchSelect
                    model_key="business_rid"
                    model_name="请输入一级商业搜索"
                    request_uri="searchAccounts"
                    default_option_key="business_option"
                    :default_option="queryParams['business_option']"
                    @onDropChange="onDropChange"
                    ref="business_rid_ref"
                ></vSearchSelect>
            </div>
            <div class="main_header_item" v-if="postList.demander_rid">
                <vSearchSelect
                    model_key="demander_rid"
                    model_name="请输入需方搜索"
                    request_uri="searchAccounts"
                    default_option_key="demander_option"
                    :default_option="queryParams['demander_option']"
                    @onDropChange="onDropChange"
                    ref="demander_rid_ref"
                ></vSearchSelect>
            </div>
            <div class="main_header_item" v-if="postList.product_rid">
                <vDropdown
                    model_key="product_rid"
                    model_name="请选择产品"
                    :model_value_default="queryParams['product_rid']"
                    request_uri="dropdownProducts"
                    :request_params="{ type_code: [11, 91] }"
                    @onDropChange="onDropChange"
                    ref="product_rid_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item" v-if="postList.product_batch_number">
                <el-input
                    v-model="queryParams.product_batch_number"
                    placeholder="请输入批号搜索"
                    clearable
                    @keyup.enter.native="getList(1)"
                ></el-input>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" plain @click="batchWriteoff" v-if="postList.batchWriteoffBtn" :loading="save_loading"
                    >批量冲销</el-button
                >

                <el-button size="small" plain @click="batchProcessPending" v-if="postList.batchProcessBtn" :loading="save_loading"
                    >批量处理</el-button
                >
                <el-button size="small" plain @click="show_help()" icon="el-icon-question">帮助信息</el-button>
                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(1)" v-if="postList.searchBtn">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset" v-if="postList.resetBtn">重置</el-button>
                    <draggableList :draggable="draggable" @isErrShow="onSetFieldDone" v-if="postList.setBtn"></draggableList>
                </div>
            </div>
            <div v-show="is_show_help">
                <div class="flex">
                    <span style="color: red; font-size: 13px">
                        注意：批量冲销只对当前分页有效，请勿跨分页操作。只选正流向或只填冲销数量或冲销数量不符合要求的行会被忽略</span
                    >
                    <span style="color: blue; font-size: 13px">（如需多对多冲销，请点击列表右侧+-按钮）&nbsp;&nbsp;&nbsp;&nbsp; </span>
                </div>
                <div class="flex">
                    <span style="color: red; font-size: 13px"> 批量冲销完后，点击批量处理按钮，对冲销后实际大于数量的正流向进行重算</span>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                :max-height="this.$tableHeight"
                class="commodity_flow_negative"
                @header-dragend="changeColWidth"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <el-table-column label="正流向" width="360">
                    <template slot-scope="scope" style="height: 100%">
                        <vSearchSelect
                            style="width: 100%"
                            :model_key="scope.row['rid']"
                            :extend="{ rid: scope.row['rid'] }"
                            model_name="示例：2022-01-01或CMFL0000000001或*"
                            request_uri="searchFlows"
                            search_value_validate="flow_validate"
                            :default_option_key="scope.row['rid']"
                            :default_option="optionData[scope.row['rid']] || ''"
                            @onDropChange="onDropChange1"
                        ></vSearchSelect>
                    </template>
                </el-table-column>

                <el-table-column label="冲销数量" width="160">
                    <template slot-scope="scope">
                        <el-input clearable placeholder="请输入冲销数量" v-model="formDataNum[scope.row['rid']]"></el-input>
                    </template>
                </el-table-column>

                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope" style="height: 100%">
                            <div v-if="in_array(item.prop, ['xxx'])">
                                <el-link type="primary" @click="toDetail(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>

                <el-table-column label="操作" width="60" fixed="right">
                    <template slot-scope="scope" style="height: 100%">
                        <el-tooltip class="item" effect="dark" content="复制行" placement="top-start">
                            <i class="el-icon-circle-plus" @click="add(scope.row, scope.$index)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="删除行" placement="top-start" style="margin-left: 5px">
                            <i class="el-icon-remove" @click="remove(scope.row, scope.$index)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page="queryParams.page"
                    :page-size="queryParams.row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import vSearchSelect from '@/components/common/dropdown/search.vue';
import { onReSize, onSearch, in_array } from '../../../../../js/common';
import draggableList from '../../../../common/Drawer.vue';

export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList,
        vSearchSelect
    },
    name: 'flowNegativeListComponent',
    data() {
        return {
            is_show_help: false,
            draggable: {
                data_name: 'commodity_flow_negative'
            },
            save_loading: false,
            loading: true,
            tableData: [],
            colData: [],
            total: 0,
            // sort: '', //排序参数
            // data_name: '', //排序参数
            queryParams: {},
            accountDropData: [],
            formDataNum: {},
            formDataRelRid: {},
            optionData: {}
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    beforeMount() {
        this.recoveryQueryParams('page');
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            this.recoveryQueryParams();
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.queryParams.row = 10;
                // 填入相应的参数，调用getList(0);
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        in_array,
        show_help() {
            this.is_show_help = this.is_show_help == false ? true : false;
        },
        //跳转详情
        toDetail(row, prop) {},
        initQueryParams() {
            this.queryParams = {
                page: 1,
                row: 25,
                is_export: 0,
                source_file: '',
                rid: '',
                business_rid: '',
                product_rid: '',
                demander_rid: '',
                product_batch_number: ''
            };
            this.saveQueryParams();
        },
        onDropChange(key, value) {
            this.queryParams[key] = value;
        },
        onDropChange1(key, value, type) {
            if (type == 'value') {
                this.formDataRelRid[key] = value;
            } else {
                this.optionData[key] = value;
            }
        },
        saveQueryParams() {
            if (!this.postList.params) {
                localStorage.setItem('commodity_flow_negative_params', JSON.stringify(this.queryParams));
            }
        },
        // 分页参数需要在beforeMount初始化，先兼容下
        recoveryQueryParams(type = 'common') {
            //详情内调用不用本地存储的params
            if (!this.postList.params) {
                //列表页面调用 优先取本地存储
                const queryParams = JSON.parse(localStorage.getItem('commodity_flow_negative_params'));
                if (queryParams) {
                    if (type == 'common') {
                        this.queryParams = queryParams;
                    } else {
                        this.queryParams.page = queryParams.page || 1;
                        this.queryParams.row = queryParams.row || 25;
                    }
                } else {
                    this.initQueryParams();
                }
            }
        },
        //子组件更新完毕
        onSetFieldDone(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('commodity_flow_negative', this, 1);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).commodity_flow_negative;
        },
        // 获取列表 0-非搜索 1-搜索 2-下载
        getList(search_type = 0) {
            // 因为存在 + - 号，以及搜索后内容可能发生变化，所以每次触发搜索、重置、分页等操作，直接把已填写的关联清空掉
            // 流向、库存 关联 xxx 其实也有这个问题，暂时不动
            this.formDataNum = {};
            this.formDataRelRid = {};
            this.optionData = {};

            onSearch(search_type, this, 'flowNegativeList');
        },
        currentChange(page) {
            this.queryParams.page = page;
            this.saveQueryParams();
            this.getList(0);
        },
        sizeChange(row) {
            this.queryParams.row = row;
            this.saveQueryParams();
            this.getList(0);
        },
        // 保存
        save(row) {},
        // 批量冲销
        batchWriteoff() {
            if (JSON.stringify(this.formDataNum) == '{}' || JSON.stringify(this.formDataRelRid) == '{}') {
                this.$message.warning('至少完整填写一行才能进行批量冲销');
                return false;
            }

            this.$confirm('您确定要批量冲销吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.save_loading = true;
                    this.$api['flowNegativeWriteOff']({
                        number: this.formDataNum,
                        map: this.formDataRelRid
                    })
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    message: '操作成功!',
                                    type: 'success'
                                });
                                this.reload();
                            }
                        })
                        .catch((error) => {
                            this.save_loading = false;
                            this.reload();
                        });
                })
                .catch(() => {});
        },
        batchProcessPending() {
            this.$confirm('您确定要批量处理吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.save_loading = true;
                    this.$api['flowNegativeProcess']({})
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    message: '操作成功!',
                                    type: 'success'
                                });
                                this.reload();
                            }
                        })
                        .catch((error) => {
                            this.save_loading = false;
                        });
                })
                .catch(() => {});
        },
        add(row, index) {
            let new_row = JSON.parse(JSON.stringify(row));
            let temp = new_row.rid.split('_');
            new_row.rid = temp[0] + '_' + Math.random();

            this.tableData.splice(index + 1, 0, new_row);
        },
        remove(row, index) {
            delete this.formDataNum[row.rid];
            delete this.formDataRelRid[row.rid];
            delete this.optionData[row.rid];
            this.tableData.splice(index, 1);
        },
        reset() {
            this.initQueryParams();
            this.getList();
        }
    }
};
</script>
<style lang="scss" scoped>
</style>